export const generateUuid = (() => {
  if (window &&
      window.crypto &&
      (typeof window.crypto.randomUUID === "function")
  ){
    return window.crypto.randomUUID()
  }
  // Should never enter here as only i.e. doesn't support this api
  // https://developer.mozilla.org/en-US/docs/Web/API/Crypto/randomUUID
  console.warn(`Using a legacy browser that doesn't support window cryptographic API`)
  const d = new Date().getTime()
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16
    if(d > 0){
      r = (d + r)%16 | 0
    }
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  });
});
